import { render, staticRenderFns } from "./screening-task.vue?vue&type=template&id=7e0d4b71&scoped=true"
import script from "./screening-task.vue?vue&type=script&lang=js"
export * from "./screening-task.vue?vue&type=script&lang=js"
import style0 from "./screening-task.vue?vue&type=style&index=0&id=7e0d4b71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0d4b71",
  null
  
)

export default component.exports